import { Cache } from './main.js'

export class LogCache extends Cache {
	constructor(settings={}) {
		super('log-cache', settings, 'uid', (item) => `${new Date().getTime()}_${item.id}`)
	}
}